import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  container: css`
    display: flex;
    justify-content: center;
    align-items: flex-start;

    height: calc(100vh - 64px);
    overflow-y: auto;
    padding: 24px;

    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
      display: none;
    }

    @media (max-width: 768px) {
      padding: 14px 0px;
      overflow-x: hidden;
    }

    @media (max-width: 360px) {
      padding: 12px 0px;
    }
  `,

  card: ({ theme }) => css`
    display: flex;
    flex-direction: column;

    width: 100%;
    max-width: 600px;
    margin: 0 16px;

    background-color: ${theme.colors.neutral.variant[0]};
    border-radius: 16px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
    padding: 32px;

    @media (max-width: 480px) {
      margin: 0;
      padding: 20px 10px;
    }

    @media (max-width: 360px) {
      border-radius: 12px;
      box-shadow: 0 2px 16px rgba(0, 0, 0, 0.06);
      padding: 20px 10px;
    }
  `,

  header: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 32px;
    text-align: center;
    gap: 12px;

    @media (max-width: 360px) {
      margin-bottom: 24px;
      gap: 8px;
    }
  `,

  subtitle: css`
    text-align: left;

    @media (max-width: 360px) {
      text-align: center;
    }
  `,

  questionsContainer: css`
    display: flex;
    flex-direction: column;
    gap: 36px;
    margin-bottom: 32px;

    @media (max-width: 480px) {
      gap: 28px;
    }

    @media (max-width: 360px) {
      gap: 20px;
      margin-bottom: 24px;
    }
  `,

  questionGroup: css`
    display: flex;
    flex-direction: column;
    gap: 8px;

    @media (max-width: 360px) {
      gap: 6px;
    }
  `,

  questionText: css`
    display: block;

    @media (max-width: 360px) {
      font-size: 0.95rem;
      text-align: center;
    }
  `,

  answerGroup: css`
    display: flex;
    align-items: center;
    gap: 16px;
    justify-content: space-between;

    @media (max-width: 480px) {
      gap: 12px;
    }

    @media (max-width: 360px) {
      flex-direction: column;
      align-items: stretch;
      gap: 10px;
    }
  `,

  answerInput: css`
    display: flex;
    gap: 8px;
    justify-content: space-between;
    flex-direction: column;
  `,
  questionHeader: css`
    display: flex;
    gap: 8px;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
  `,

  yesNoButtons: css`
    display: flex;
    gap: 8px;

    @media (max-width: 360px) {
      width: 100%;
      gap: 6px;
    }
  `,

  yesNoButton: ({ theme }) => css`
    height: 26px;
    padding: 4px 9px 4px 4px;
    gap: 6px;
    border-radius: 12px;
    color: ${theme.colors.neutral.variant[70]};

    @media (max-width: 360px) {
      flex: 1;
      justify-content: center;
      height: 28px;
      gap: 4px;
      padding: 4px 8px;
    }
  `,

  suggestionsList: ({ theme }) => css`
    margin: 0;
    padding-left: 22px;
    li {
      color: ${theme.colors.neutral.variant[60]};
      font-size: 10px;

      @media (max-width: 360px) {
        font-size: 9px;
      }
    }
  `,

  submitButton: css`
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 16px;
  `,

  footer: ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: 4px;
    border-top: 1px solid ${theme.colors.neutral.variant[20]};
    padding-top: 14px;
    text-align: center;

    @media (max-width: 360px) {
      gap: 2px;
      font-size: 0.95rem;
    }
  `,
  emailContainer: ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    flex-direction: row;
    text-align: center;
    margin-bottom: 14px;

    a {
      color: ${theme.colors.secondary.sky[50]};
      text-decoration: underline;
    }

    @media (max-width: 360px) {
      margin-top: 12px;
      flex-direction: column;
      gap: 2px;
    }
  `,

  pillsContainer: css`
    display: flex;
    min-width: 0;
    flex-wrap: wrap;

    gap: 8px;
    align-items: center;

    @media (max-width: 360px) {
      gap: 6px;
    }
  `,

  rangeInputContainer: css`
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;

    > div {
      flex: 1;
      max-width: 120px;
    }

    @media (max-width: 360px) {
      flex-direction: column;
      align-items: stretch;

      > div {
        max-width: none;
      }
    }
  `,
  input: css`
    & > div {
      flex-wrap: wrap;

      input {
        flex: 1 0 120px;
      }
    }
  `,
  rangeSlideContainer: css`
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;

    @media (max-width: 360px) {
      flex-direction: column;
      align-items: stretch;
      gap: 10px;
    }
  `,
  dropdownButton: ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    color: ${theme.colors.neutral.variant[70]};
    width: 90px;
    justify-content: flex-end;

    @media (max-width: 360px) {
      align-self: flex-end;
      width: auto;
    }
  `,
  unitDropdownMenu: css`
    z-index: 3;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
